import React from 'react'


export default function Beauty1() {
    return (
       
   
      <div className='section_heading'>
        <h1>Kalpataru <span>Beautycare</span> Treatment</h1>
        </div>
    

       
    )
}
